<template>
  <b-overlay :show="loaded" rounded="sm">
    <b-list-group>
      <b-list-group-item class="d-flex justify-content-between">
        <div class="form-check">
          <label class="form-check-label lh-base">
            <input
              type="checkbox"
              class="form-check-input top-2"
              id="checkbox-expandedList"
              v-model="isExpanded"
              name="checkbox-expandedList"
              :value="true"
              :unchecked-value="false"
            />
            {{ $translate("expand") }}
            <i class="input-helper"></i>
          </label>
        </div>

        <b-button-group size="sm">
          <b-button
            v-show="permissionGroups.length > 0"
            class="me-2 test-check_all_btn"
            variant="info"
            @click="doCheckAll(true)"
          >
            {{ $translate("check_all") }}
          </b-button>
          <b-button
            class="uncheck_all"
            v-show="permissionGroups.length > 0"
            variant="info"
            @click="doCheckAll(false)"
          >
            {{ $translate("uncheck_all") }}
          </b-button>
        </b-button-group>
      </b-list-group-item>
      <div ref="stickyContainer" class="sticky-container">
        <b-list-group-item ref="stickyRow" class="sticky-row">
        <b-row>
          <b-col cols="2">
            <h6>{{ $translate("no") }}</h6>
          </b-col>
          <b-col cols="3" md="5">
            <h6>{{ $translate("activity_types") }}</h6>
          </b-col>
          <b-col cols="1">
            <h6 class="d-block d-md-none">
              {{ $translate("view_role_short") }}
            </h6>
            <h6 class="d-none d-md-block">{{ $viewLabel() }}</h6>
          </b-col>
        </b-row>
      </b-list-group-item>
      <b-list-group-item
        v-for="(item, idx) in permissionGroups"
        :key="`section--${idx}`"
      >
        <b-row>
          <b-col cols="2">{{ idx + 1 }}</b-col>
          <b-col cols="3" md="5">
            <p>{{ item.section | formatSlug }}</p>
          </b-col>
          <b-col cols="1">
            <div class="form-check">
              <label class="form-check-label">
                <input
                  type="checkbox"
                  @change="updateValues"
                  :id="`view-${idx}`"
                  v-model="item.actions['view']"
                  name="checkbox-1"
                  :value="true"
                  :unchecked-value="false"
                  :disabled="permission_creating"
                />
                <i class="input-helper"></i>
              </label>
            </div>
          </b-col>
        </b-row>
      </b-list-group-item>
      </div>
    </b-list-group>
  </b-overlay>
</template>
<script>
import { capitalCase } from "change-case";
import activityPermissionMixins from "@/mixins/activityPermissionMixins";
import _ from 'lodash';
export default {
  name: "PermissionGroups",
  data() {
    return {
      loaded: false,
      permissionGroups: [],
      isExpanded: false,
      permission_creating: false,
      isSticky: false,
      initialOffset: null, // Store the initial offset position
    };
  },
  props: ["value"],
  mixins: [activityPermissionMixins],
  filters: {
    formatSlug(slug) {
      return capitalCase(slug.split(".").join("-"));
    },
  },
  computed: {
    activityPermissions_list() {
      return this.$store.state.permissions.activityPermissions_list;
    },
  },
  watch: {
    value: {
      handler: function (val) {
        this.setModel(val);
      },
      deep: true,
    },
    isExpanded: function () {
      this.setModel(this.value);
    },
    activityPermissions_list: {
      handler: function () {
        this.$nextTick(() => {
          this.updateValues();
        });
      },
      deep: true,
    },
  },
  mounted() {
    console.log("mounted---value", this.value);
    this.setModel(this.value);
    console.log(
      "mounted---activityPermissions_list",
      this.activityPermissions_list
    );
    window.addEventListener('scroll', this.handleScrollDebounced);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScrollDebounced);
  },
  methods: {
    updateValues() {
      console.log("function5", this.permissionGroups);
      let values = [];
      for (const value of this.permissionGroups) {
        for (const actionKey in value.actions) {
          if (value.actions[actionKey]) {
            const slug = `${actionKey}.${value.section}`
              .split(" ")
              .join(".")
              .toLowerCase();

            const name = capitalCase(`${actionKey} ${value.section}`);
            const id = value.type_id;
            values.push({
              name,
              slug,
              id,
            });
          }
        }
      }
      console.log("new permission permissionGroups", values);
      this.$emit("input", values);
    },
    sleeper(ms) {
      console.log("function4");
      return new Promise((resolve) => setTimeout(() => resolve(), ms));
    },
    loader(select) {
      this.loaded = select;
    },
    async doCheckAll(selected) {
      this.loader(true);

      for (let i = 0; i < this.permissionGroups.length; i++) {
        const { section, type_id } = this.permissionGroups[i];
        const actions = {
          view: selected,
        };

        // Update the actions for the current permission group
        this.$set(this.permissionGroups, i, {
          section,
          actions,
          type_id,
        });
      }

      this.updateValues();
      this.loader(false);
    },

    setModel(values) {
      const _groupedSections = (values || [])
        .filter((x) => x)
        .reduce((_list, x) => {
          console.log("_groupedSections x", x);
          const parts = x.slug.split(".");
          const action = parts[0];
          const section = parts.slice(1).join(".");
          const idx = _list.findIndex((x) => x.section === section);
          console.log("action:", action);
          console.log("section:", section);
          console.log("idx:", idx);

          if (idx < 0) {
            const actions = {
              view: false,
            };
            actions[action] = true;
            _list.push({
              section,
              actions,
            });
          } else {
            const obj = _list[idx];
            obj.actions[action] = true;
            _list.splice(idx, 1, obj);
          }
          return _list;
        }, []);

      const slugSections = this.activitySections.map((x) =>
        x.name.split(" ").join(".").toLowerCase()
      );

      const _cleanGroupedSections = slugSections.map((section, index) => {
        const _groupSection = _groupedSections.find(
          (_group) => _group.section === section
        );
        if (_groupSection) {
          return {
            ..._groupSection,
            type_id: this.activitySections[index].id,
          };
        }

        const actions = {
          view: false,
        };
        return {
          section,
          actions,
          type_id: this.activitySections[index].id,
        };
      });

      _cleanGroupedSections.sort((a, b) => {
        if (a.section > b.section) return 1;
        else if (b.section > a.section) return -1;
        else return 0;
      });

      console.log("_cleanGroupedSection", _cleanGroupedSections);
      const { isExpanded } = this;
      this.permissionGroups = _cleanGroupedSections.filter((x) => {
        if (isExpanded) return true;
        else {
          let allFalse = false;
          for (const prop in x.actions) {
            allFalse = allFalse || x.actions[prop];
          }
          return allFalse;
        }
      });
    },
    handleScrollDebounced: _.debounce(function() {
    const stickyRow = this.$refs.stickyRow;
    const stickyContainer = this.$refs.stickyContainer;
    const stickyRowRect = stickyRow.getBoundingClientRect();
    const containerRect = stickyContainer.getBoundingClientRect();
    const offset = 70; // Adjust this value to avoid hiding under the header

    if (this.initialOffset === null) {
      this.initialOffset = stickyRowRect.top; // Store the initial top offset of the element
    }

    // Calculate the top and bottom positions of the container relative to the page
    const containerTop = containerRect.top + window.scrollY;
    const containerBottom = containerRect.bottom + window.scrollY;

    // Check if the stickyRow should be sticky
    if (window.scrollY + offset > containerTop && window.scrollY + offset < containerBottom - stickyRowRect.height) {
      stickyRow.classList.add('sticky');
      stickyRow.style.width = `${stickyContainer.offsetWidth}px`; // Set width to match container width
      stickyRow.style.top = `${offset}px`;
      this.isSticky = true;
    } 
    // If stickyRow reaches the bottom of the container
    else if (window.scrollY + offset >= containerBottom - stickyRowRect.height) {
      stickyRow.classList.remove('sticky');
      stickyRow.style.width = `${stickyContainer.offsetWidth}px`; // Set width to match container width
      stickyRow.style.top = `${containerBottom - stickyRowRect.height - window.scrollY}px`; // Pin to the bottom of the container
      this.isSticky = false;
    } 
    // If stickyRow reaches the top of the container
    else if (window.scrollY + offset <= containerTop) {
      stickyRow.classList.remove('sticky');
      stickyRow.style.width = '100%'; // Ensure it matches the container width when not sticky
      stickyRow.style.top = 'unset'; // Reset top when not sticky
      this.isSticky = false;
    }
  }, 100),
  },
};
</script>
